import { AppConfig } from '../services/config/config.service';
import { DeviceTypeModel, getDeviceType } from 'qp-utility';

declare global {
  interface Window {
    // vizio
    vizioLMT: any;
    vizioIFA_TYPE: any;
    vizioIFA: any;
    // tizen
    webapis: any;
    // client
    appClient: any;
  }
}

export declare type AppClient = 'tve' | 'dtc';

/**
 * Get the x-client-id based on the device type
 * If the device type is Vizio, ignore the Vizio
 *
 * @param ignoreVizio
 * @returns
 */
export const getXClientId = (): string => {
  return `unow-unow${getAppClient()}-x1`;
};

/**
 * Get the client type based on window env value
 * Default dtc value
 * TODO: confirm final values
 */
export const getAppClient = (): AppClient => {
  return window.appClient === 'unowtve-comcast' ? 'tve' : 'dtc';
};

/**
 * Check if the client is TVE based on window env value
 */
export const isClientTVE = () => {
  return window.appClient === 'unowtve-comcast';
};

/**
 * Check if the client is DTC based on window env value
 */
export const isClientDTC = () => {
  return window.appClient === 'unowdtc-comcast';
};

/**
 * Get the ad platform id based on the device type and platform support
 *
 * @returns
 */
export const getIFAPlatform = async (applicationConfig: AppConfig): Promise<string> => {
  const deviceType = getDeviceType();
  if (deviceType === DeviceTypeModel.VIZIO) {
    return window.vizioIFA;
  } else if (deviceType === DeviceTypeModel.SAMSUNG) {
    return window?.webapis?.adinfo?.getTIFA() ?? '';
  } else if (deviceType === DeviceTypeModel.COMCAST) {
    return applicationConfig.adTagIdType ?? 'sspid';
  }
  return '';
};

/**
 * Get the ad platform id based on the device type and platform support
 *
 * @returns
 */
export const getIFATypePlatform = (): string => {
  const deviceType = getDeviceType();
  if (deviceType === DeviceTypeModel.VIZIO) {
    return window.vizioIFA_TYPE !== undefined && window.vizioIFA_TYPE !== null ? window.vizioIFA_TYPE : '0';
  } else if (deviceType === DeviceTypeModel.SAMSUNG) {
    return 'tifa';
  }
  return '0';
};

export const getLMTPlatform = (): string => {
  const deviceType = getDeviceType();
  if (deviceType === DeviceTypeModel.VIZIO) {
    // vizio ask for the ad tracking status
    // if is on lmt = true
    // if is off lmt = false
    return window.vizioLMT !== undefined && window.vizioLMT !== null && window.vizioLMT ? '1' : '0';
  } else if (deviceType === DeviceTypeModel.SAMSUNG) {
    // tizen ask for the user acepts the ad tracking
    // if the user accepts, there is no limit for ad tracking lmt = 0
    // if the user don't accept, ads are limited lmt = 1
    return window?.webapis?.adinfo?.isLATEnabled() ? '1' : '0'; // samsung lmt is true/false
  } else if (deviceType === DeviceTypeModel.COMCAST) {
    // TODO: implement firebolt ad interface calls
  }
  return '0';
};

/**
 * Check if the keycode is valid for vizio keyword input
 * Give support to Alphanumerical Keys and Special Characters vizio keycodes and backspace
 *
 * @param keycode
 * @returns
 */
export const isKeycodeVizioValid = (keycode: number) => {
  return [
    8, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87,
    88, 89, 90, 44, 45, 46, 47, 58, 59, 60, 61, 62, 63, 64, 92, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 174, 175, 176,
    219, 220, 221, 222,
  ].includes(keycode);
};
